(function() {
    'use strict';

    function validatePublicForm(form) {
        if (!form) {
            return false;
        }

        const isValid = typeof form.checkValidity === 'function' ? form.checkValidity() : true;
        if (!isValid) {
            form.classList.add('was-validated');
            if (typeof form.reportValidity === 'function') {
                form.reportValidity();
            }
            return false;
        }

        form.classList.remove('was-validated');
        return true;
    }

    function resolveConsentContainer(consentCheckbox, options = {}) {
        const { findErrorContainer } = options;
        if (typeof findErrorContainer === 'function') {
            return findErrorContainer(consentCheckbox);
        }

        return consentCheckbox?.closest('.consent-checkbox') || null;
    }

    function validatePublicConsentCheckbox(consentCheckbox, options = {}) {
        if (!consentCheckbox) {
            return false;
        }

        if (consentCheckbox.checked) {
            clearPublicConsentValidation(consentCheckbox, options);
            return true;
        }

        const {
            errorMessage = 'Необходимо дать согласие на обработку персональных данных',
            scrollIntoView = true
        } = options;

        consentCheckbox.classList.add('is-invalid');
        const container = resolveConsentContainer(consentCheckbox, options);
        if (container) {
            let errorElement = container.querySelector('.consent-error-message');
            if (!errorElement) {
                errorElement = document.createElement('div');
                errorElement.className = 'consent-error-message text-danger small mt-1';
                errorElement.textContent = errorMessage;
                container.appendChild(errorElement);
            }
            errorElement.style.display = 'block';
        }

        if (scrollIntoView && typeof consentCheckbox.scrollIntoView === 'function') {
            consentCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        return false;
    }

    function clearPublicConsentValidation(consentCheckbox, options = {}) {
        if (!consentCheckbox) {
            return;
        }

        consentCheckbox.classList.remove('is-invalid');
        const container = resolveConsentContainer(consentCheckbox, options);
        const errorElement = container?.querySelector('.consent-error-message');
        if (errorElement) {
            errorElement.style.display = 'none';
        }
    }

    if (typeof window !== 'undefined') {
        window.PublicFormValidation = {
            validateForm: validatePublicForm,
            validateConsentCheckbox: validatePublicConsentCheckbox,
            clearConsentValidation: clearPublicConsentValidation
        };
    }
})();
